"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedicons = require("@bit/gerenciatd.unifiedicons.svg-icon");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pathSolid = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M6.152,7.927V18.906H2.5V7.927Zm.233-3.39a1.754,1.754,0,0,1-.56,1.352,2.088,2.088,0,0,1-1.5.543H4.3a2,2,0,0,1-1.462-.543,1.816,1.816,0,0,1-.554-1.352,1.786,1.786,0,0,1,.571-1.357,2.082,2.082,0,0,1,1.49-.537,2.03,2.03,0,0,1,1.473.537,1.847,1.847,0,0,1,.565,1.357ZM19.3,12.613v6.293H15.657V13.034a3.207,3.207,0,0,0-.449-1.823,1.575,1.575,0,0,0-1.4-.659,1.8,1.8,0,0,0-1.169.382,2.355,2.355,0,0,0-.7.947,2.684,2.684,0,0,0-.122.9V18.9H8.168q.022-4.42.022-7.168T8.179,8.458l-.011-.532h3.645v1.6h-.022a4.841,4.841,0,0,1,.454-.62,4.71,4.71,0,0,1,.626-.576,2.88,2.88,0,0,1,.964-.482A4.391,4.391,0,0,1,15.1,7.67,3.935,3.935,0,0,1,18.15,8.928,5.276,5.276,0,0,1,19.3,12.612Z",
    transform: "translate(-2.285 -2.642)"
  })
});

var Linkedin = function Linkedin(props) {
  var kind = props.kind;
  var path = null;

  switch (kind) {
    default:
      path = pathSolid;
  }

  var viewBox = props.viewBox,
      mainDimension = props.mainDimension;

  if (!viewBox) {
    viewBox = '-0.5 -0.5 18 18';
  }

  if (!mainDimension) {
    mainDimension = 'x';
  }

  var Icon = (0, _gerenciatdUnifiedicons.CreateSvgIcon)(path, "Linkedin-".concat(kind));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: viewBox,
    mainDimension: mainDimension
  }));
};

var _default = Linkedin;
exports["default"] = _default;

//# sourceMappingURL=index.js.map